// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__xqYW3","title":"InfoRow_title__28yXy"};